import { render, staticRenderFns } from "./shelf_channel_dialog.vue?vue&type=template&id=df0906b4&scoped=true"
import script from "./shelf_channel_dialog.vue?vue&type=script&lang=js"
export * from "./shelf_channel_dialog.vue?vue&type=script&lang=js"
import style0 from "./shelf_channel_dialog.vue?vue&type=style&index=0&id=df0906b4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0906b4",
  null
  
)

export default component.exports